// extracted by mini-css-extract-plugin
export var clutch_box = "footerClutch-module--clutch_box--1751e";
export var counter = "footerClutch-module--counter--2a3e6";
export var counter_container = "footerClutch-module--counter_container--fec8e";
export var counter_listing = "footerClutch-module--counter_listing--d305a";
export var counter_wrapper = "footerClutch-module--counter_wrapper--65488";
export var imageBox = "footerClutch-module--imageBox--9507d";